import { api } from "./config";

const aditivoService = {
  /**
   * Gerar aditivo
   * @param Number idPropostaRepactuacao
   * @param chave chave UID proposta
   */
  gerarAditivo: (idPropostaRepactuacao, chave) => {
    return api.get(
      `/propostarepactuacao/gerarAditivo?idPropostaRepactuacao=${idPropostaRepactuacao}`,
      {
        responseType: "arraybuffer",
        headers: { "g-recaptcha-response": chave },
      }
    );
  },

  /**
   *
   * @param {AditivoEnviarRequest} aditivoEnviarRequest
   * @param chave chave UID proposta
   * @returns {Promise<AxiosResponse<Object>>}
   */
  uploadArquivo(aditivoEnviarRequest, chave) {
    const request = {
      base64: aditivoEnviarRequest.base64,
      idPropostaRepactuacao: aditivoEnviarRequest.idPropostaRepactuacao,
      tipo: aditivoEnviarRequest.tipo,
    };
    return api.post(`/propostarepactuacao/enviarAditivo`, request, {
      headers: {
        "content-type": "application/json",
        "g-recaptcha-response": chave,
      },
    });
  },
  /**
   *
   * @param {documentoDTO} DocumentoDTO
   * @param chave chave UID proposta
   * @returns {Promise<AxiosResponse<Object>>}
   */
  uploadComprovacao(objRequest, documento1, documento2, idPropostaRepactuacao, chave) {
    let documentos = [];
    if (documento1 != null && documento1 != undefined) {
      documentos.push({
        base64: documento1.base64,
        idPropostaRepactuacao: objRequest.idPropostaRepactuacao,
        tipo: documento1.tipo,
      });
    }
    if (documento2 != null &&  documento2 != undefined) {
      documentos.push({
        base64: documento2.base64,
        idPropostaRepactuacao: objRequest.idPropostaRepactuacao,
        tipo: documento2.tipo,
      });
    }
    const request = {
      idPropostaRepactuacao: objRequest.idPropostaRepactuacao,
      enquadramento: objRequest.enquadramento,
      faturamento1: objRequest.faturamento1,
      faturamento2: objRequest.faturamento2,
      documentos: documentos,
    };
    return api.post(
      `/propostarepactuacao/enviarDocumentoComprovacao`,
      request,
      {
        headers: {
          "content-type": "application/json",
          "g-recaptcha-response": chave,
        },
      }
    );
  },
};

export default aditivoService;
